import React from "react";
import "./ReviewWizardSteps.scss";

export default function ReviewWizardSteps({ currentStep, onSummary, onReviewChecklist, onNavigate, engagementName, checklistName }) {
  const steps = [
    { label: "Review Summary", action: onSummary },
    { label: "Review Checklist", action: onReviewChecklist },
  ];
  return <nav className="review-wizard-steps" aria-label="Review steps">
    <ol>{steps.map((step, index) => {
      const number = index + 1;
      return <li key={step.label} className={number === currentStep ? "is-current" : number < currentStep ? "is-previous" : ""}>
        <button type="button" aria-current={number === currentStep ? "step" : undefined}
          disabled={number === currentStep || !step.action} onClick={() => { if (onNavigate) onNavigate(step.action); else step.action?.(); }}>
          <span>{number}</span><div className="review-wizard-steps__label"><b>{step.label}</b>
            {number === 1 && engagementName && <small>{engagementName}</small>}
            {number === 2 && (checklistName || engagementName) && <small>{checklistName || engagementName}</small>}
          </div>
        </button>
      </li>;
    })}</ol>
  </nav>;
}
